module.exports = __webpack_public_path__ + "static/media/notification.fcae242e.mp3";